export default "__VITE_PUBLIC_ASSET__a9f2e3f0__"